/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatabaseTargetAuthDatabaseTargetIamRoleAuthFromJSONTyped, DatabaseTargetAuthDatabaseTargetIamRoleAuthToJSON, } from './DatabaseTargetAuthDatabaseTargetIamRoleAuth';
import { DatabaseTargetAuthDatabaseTargetPasswordAuthFromJSONTyped, DatabaseTargetAuthDatabaseTargetPasswordAuthToJSON, } from './DatabaseTargetAuthDatabaseTargetPasswordAuth';
export function DatabaseTargetAuthFromJSON(json) {
    return DatabaseTargetAuthFromJSONTyped(json, false);
}
export function DatabaseTargetAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    switch (json['kind']) {
        case 'IamRole':
            return Object.assign({}, DatabaseTargetAuthDatabaseTargetIamRoleAuthFromJSONTyped(json, true), { kind: 'IamRole' });
        case 'Password':
            return Object.assign({}, DatabaseTargetAuthDatabaseTargetPasswordAuthFromJSONTyped(json, true), { kind: 'Password' });
        default:
            throw new Error(`No variant of DatabaseTargetAuth exists with 'kind=${json['kind']}'`);
    }
}
export function DatabaseTargetAuthToJSON(value) {
    if (value == null) {
        return value;
    }
    switch (value['kind']) {
        case 'IamRole':
            return DatabaseTargetAuthDatabaseTargetIamRoleAuthToJSON(value);
        case 'Password':
            return DatabaseTargetAuthDatabaseTargetPasswordAuthToJSON(value);
        default:
            throw new Error(`No variant of DatabaseTargetAuth exists with 'kind=${value['kind']}'`);
    }
}
